import React from "react";

const OtherBillIcon = ({ width, height, color }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="28"
        height="28"
        rx="3"
        fill="#F1F7FA"
        stroke="#064A72"
        strokeWidth="2"
      />
      <path
        d="M15.0001 6.66663C10.4001 6.66663 6.66675 10.4 6.66675 15C6.66675 19.6 10.4001 23.3333 15.0001 23.3333C19.6001 23.3333 23.3334 19.6 23.3334 15C23.3334 10.4 19.6001 6.66663 15.0001 6.66663ZM19.1667 15.8333H15.8334V19.1666H14.1667V15.8333H10.8334V14.1666H14.1667V10.8333H15.8334V14.1666H19.1667V15.8333Z"
        fill="black"
      />
    </svg>
  );
};

export default OtherBillIcon;
